export default __webpack_public_path__ + "static/media/jp.de18fe69.jpg";